import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid } from '@material-ui/core';
import AdCard from '../AdCard';
import useStyles from './adset-styles';
import { withTranslation } from '../../i18n';
import routerLink from '../../static/text/link';

function AdSet(props) {
  const classes = useStyles();
  const {
    className, alignItems, i18n,
    fixedElement, maxHeight, fixedStyle,
    adCardStyle
  } = props;
  const currentLanguage = i18n.language;
  const [isFixed, setIsFixed] = useState(false);
  const [isMaxHeight, setIsMaxHeight] = useState(false);
  const [elementHeight, setElementHeight] = useState(0);

  const ebookBanner = currentLanguage === 'id' ? require('../../static/images/mfs/banner_ebook_id.jpg') : require('../../static/images/mfs/banner_ebook_en.jpg');
  const appBanner = currentLanguage === 'id' ? require('../../static/images/mfs/banner_app_id.jpg') : require('../../static/images/mfs/banner_app_en.jpg');

  const _iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);

  const redirect = _iOSDevice ? routerLink.mobile.appStore : routerLink.mobile.playStore;

  useEffect(() => {
    const { additionalAds } = props;
    if (fixedElement && additionalAds.length === 0) {
      const adHeight = document.getElementById('adGrid').offsetTop;
      window.addEventListener('scroll', () => {
        const elem = typeof document.getElementById('adGrid') !== 'undefined' && document.getElementById('adGrid') ? document.getElementById('adGrid').clientHeight : 0;
        setElementHeight(elem);
        if (window.scrollY >= adHeight - 30) {
          setIsFixed(true);
        } else {
          setIsFixed(false);
        }
        if (window.scrollY >= maxHeight - elementHeight - 120) {
          setIsMaxHeight(true);
        } else {
          setIsMaxHeight(false);
        }
      });
    }
  }, [elementHeight, maxHeight]);

  function renderAdditionalAds() {
    const { additionalAds } = props;
    if (additionalAds.length > 0) {
      return additionalAds.map((item, idx) => <AdCard source={item.image_desktop_url} className={adCardStyle} redirect={routerLink.mobile.downloadAppRoot} key={idx} />);
    }
    return null;
  }

  return (
    <Grid id="adGrid" direction="column" container alignItems={alignItems || 'flex-end'} className={clsx(classes.root, className, isFixed ? clsx(classes.isFixed, fixedStyle) : null)} style={isMaxHeight ? { position: 'absolute', top: maxHeight - elementHeight - 60 } : null}>
      {/* <AdCard className={adCardStyle} source={ebookBanner} redirect={routerLink.mobile.downloadAppRoot} /> */}
      <AdCard className={adCardStyle} source={appBanner} redirect={redirect} />
      {renderAdditionalAds()}
    </Grid>
  );
}

AdSet.propTypes = {
  className: PropTypes.string,
  adCardStyle: PropTypes.string,
  alignItems: PropTypes.string,
  i18n: PropTypes.object.isRequired,
  fixedElement: PropTypes.bool,
  maxHeight: PropTypes.number,
  fixedStyle: PropTypes.string,
  additionalAds: PropTypes.array,
};

AdSet.defaultProps = {
  className: '',
  alignItems: '',
  fixedElement: false,
  maxHeight: 0,
  fixedStyle: '',
  adCardStyle: '',
  additionalAds: []
};

export default withTranslation(['myfitsociety'])(AdSet);
